import Page from '../Components/Page.js';
import '../styles/Page.scss';

const E404 = () =>
    <Page id="e404">
        <h1>Page introuvable</h1>
        <p>Le contenu que vous recherchez n'existe pas ou a été déplacé.</p>
    </Page>

export default E404;